
<template>
  <nav class="atlas-topnav">

    <!-- Language selector: desktop and mobile -->
    <div class="atlas-topnav-language">
      <b-dropdown
        right
        split
        text="language"
        class="language-dropdown"
        toggle-class="toggle-language"
        split-class="split-language"
      >
        <template #button-content>
          <img
            :src="currentLanguageFlag"
            width="30px"
            height="20px"
            alt="Language"
          >
        </template>

        <b-dropdown-item
          v-for="language in languages"
          :key="language.code"
          @click="selectLanguage(language.code)"
        >
          <img
            :src="language.flag"
            width="30px"
            height="20px"
            :alt="language.name"
          >
          {{ language.name }}
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <!-- Desktop navigation -->
    <div class="atlas-topnav-links">
      <a href="https://www.wynelover.com">WYNELOVER</a>
      <a href="https://www.wynecellar.com">WYNECELLAR</a>
      <a href="https://www.wynetaster.com">WYNETASTER</a>
      <a href="https://www.wynemaker.com">WYNEMAKER</a>

      <router-link
        to="/atlas"
        class="atlas-topnav-active"
      >
        WYNEATLAS
      </router-link>
    </div>

    <!-- Mobile-only branding -->
    <div class="atlas-mobile-brand">
      <span>WYNE</span>ATLAS
    </div>

    <!-- Mobile-only hamburger -->
    <button
      class="atlas-mobile-menu-button"
      type="button"
      :aria-expanded="mobileMenuOpen"
      aria-controls="atlas-mobile-links"
      :aria-label="mobileMenuOpen ? 'Close navigation' : 'Open navigation'"
      @click="mobileMenuOpen = !mobileMenuOpen"
    >
      <span v-if="mobileMenuOpen">&#10005;</span>
      <span v-else>&#9776;</span>
    </button>

    <!-- Mobile dropdown: only rendered when open -->
    <div
      v-if="mobileMenuOpen"
      id="atlas-mobile-links"
      class="atlas-mobile-links"
    >
      <a href="https://www.wynelover.com">WYNELOVER</a>
      <a href="https://www.wynecellar.com">WYNECELLAR</a>
      <a href="https://www.wynetaster.com">WYNETASTER</a>
      <a href="https://www.wynemaker.com">WYNEMAKER</a>

      <router-link
        to="/atlas"
        class="atlas-topnav-active"
        @click.native="mobileMenuOpen = false"
      >
        WYNEATLAS
      </router-link>
    </div>

  </nav>
</template>

<script>
import Cookies from 'js-cookie';

const flags = {
  en: require('@/assets/img/flags/english.png'),
  fr: require('@/assets/img/flags/francais.png'),
  de: require('@/assets/img/flags/deutsch.png'),
  es: require('@/assets/img/flags/spanish.png'),
  it: require('@/assets/img/flags/italian.png'),
  nl: require('@/assets/img/flags/dutch.png'),
  pt: require('@/assets/img/flags/portuguese.png')
};

export default {
  name: 'AtlasTopNav',

  data() {
    return {
      mobileMenuOpen: false
    };
  },

  computed: {
    currentLanguage() {
      return this.$store.state.language;
    },

    currentLanguageFlag() {
      return flags[this.currentLanguage] || flags.en;
    },

    languages() {
      return [
        { code: 'en', name: 'English', flag: flags.en },
        { code: 'fr', name: 'Français', flag: flags.fr },
        { code: 'de', name: 'Deutsch', flag: flags.de },
        { code: 'es', name: 'Español', flag: flags.es },
        { code: 'it', name: 'Italiano', flag: flags.it },
        { code: 'nl', name: 'Nederlands', flag: flags.nl },
        { code: 'pt', name: 'Português', flag: flags.pt }
      ];
    }
  },

  methods: {
    selectLanguage(language) {
      if (!Object.prototype.hasOwnProperty.call(flags, language)) {
        language = 'en';
      }

      this.$store.commit('setLanguage', language);

      Cookies.set('wynelover.language', language, {
        expires: 365,
        path: '/',
        sameSite: 'Lax'
      });
    }
  }
};
</script>

<style scoped>
/* =========================================
   TOP NAVIGATION
   ========================================= */

.atlas-topnav {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 58px;
  background-color: white;
  border-bottom: 1px solid rgb(230,230,230);
}

/* =========================================
   DESKTOP LINKS
   ========================================= */

.atlas-topnav-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: 32px;
  padding: 15px 20px;
}

.atlas-topnav-links a {
  color: rgb(112,112,112);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s;
}

.atlas-topnav-links a:hover {
  color: rgb(109,122,82);
  text-decoration: none;
}

.atlas-topnav-links .atlas-topnav-active {
  color: rgb(109,122,82);
  border-bottom: 3px solid rgb(109,122,82);
  padding-bottom: 5px;
}

/* =========================================
   LANGUAGE SELECTOR
   ========================================= */

.atlas-topnav-language {
  position: absolute;
  left: 25px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 110;
}

/* =========================================
   MOBILE ELEMENTS: HIDDEN ON DESKTOP
   ========================================= */

.atlas-mobile-brand,
.atlas-mobile-menu-button,
.atlas-mobile-links {
  display: none;
}

/* =========================================
   MOBILE
   ========================================= */

@media (max-width: 768px) {

  .atlas-topnav {
    min-height: 58px;
    padding: 0;
    justify-content: center;
  }

  /* Hide the five desktop links */

  .atlas-topnav-links {
    display: none;
  }

  /* Language selector on the left */

  .atlas-topnav-language {
    left: 10px;
  }

  /* Compact branding in the centre */

  .atlas-mobile-brand {
    display: block;
    color: black;
    font-size: 17px;
    font-weight: 600;
    white-space: nowrap;
  }

  .atlas-mobile-brand span {
    color: rgb(109,122,82);
    font-weight: 700;
  }

  /* Hamburger on the right */

  .atlas-mobile-menu-button {
    display: block;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    padding: 5px;
    border: none;
    background: transparent;
    color: rgb(109,122,82);
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    z-index: 110;
  }

  /* Dropdown below the header */

  .atlas-mobile-links {
    position: absolute;
    top: 100%;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    width: 100%;
    padding: 20px;
    background-color: white;
    border-bottom: 1px solid rgb(230,230,230);
    box-shadow: 0 4px 8px rgba(0,0,0,0.08);
    z-index: 100;
  }

  .atlas-mobile-links a {
    color: rgb(112,112,112);
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
    white-space: nowrap;
  }

  .atlas-mobile-links a:hover {
    color: rgb(109,122,82);
    text-decoration: none;
  }

  .atlas-mobile-links .atlas-topnav-active {
    color: rgb(109,122,82);
    border-bottom: 3px solid rgb(109,122,82);
    padding-bottom: 5px;
  }
}
</style>